import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ClassNames from 'classnames';
import PlayIcon from '../../images/play-button.svg';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  thumbnail: {
    maxWidth: '100%',
    height: '100%',
    objectFit: 'contain',
    position: 'absolute',
    left: 0,
  },
  playIcon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    '& img': {
      height: '70px !important',
      width: '70px !important',
    },
  },
  show: {
    visibility: 'visible',
  },
  hide: {
    visibility: 'hidden',
  },
}));

function VideoPlayer({ url, thumbnail }) {
  const classes = useStyles();
  const videoEl = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  const play = () => {
    setShowVideo(true);
    videoEl.current.play();
  };

  return (
    <div className={ClassNames(classes.root)}>
      <video
        controls
        ref={videoEl}
        className={showVideo ? classes.show : classes.hide}
      >
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <img
        src={thumbnail}
        alt=""
        className={ClassNames(
          classes.thumbnail,
          showVideo ? classes.hide : classes.show,
        )}
      />
      <IconButton
        className={ClassNames(
          classes.playIcon,
          showVideo ? classes.hide : classes.show,
        )}
        onClick={play}
        aria-label="Play"
      >
        <img src={PlayIcon} alt="" />
      </IconButton>
    </div>
  );
}

VideoPlayer.propTypes = {
  url: PropTypes.string,
  thumbnail: PropTypes.string,
};

export default VideoPlayer;
